import CameraStatusUpdateTile from '../CameraStatusUpdateTile'
import VersionIcon from 'assets/icons/status/VersionIcon'

const UpdateTile = ({ value, update }) => (
  <CameraStatusUpdateTile label="camera.flex.version" icon={<VersionIcon />} value={value} update={update} useSVGIcon />
)

export default UpdateTile
